export const VENDOR_PROFILE = {
  companyName: 'Al-Futtaim Logistics',
  vendorId: 'VND-TRP-001',
  contractRef: 'OGTS-SLA-2026-442',
  activeJobs: 4,
};

export const JOB_STATUS = {
  accepted: { label: 'Accepted', className: 'bg-emerald-500/15 text-emerald-700 ring-emerald-500/30' },
  in_transit: { label: 'In-Transit', className: 'bg-logi-accent/100/15 text-blue-700 ring-blue-500/30' },
  pending: { label: 'Pending', className: 'bg-amber-500/15 text-amber-700 ring-amber-500/30' },
};

export const ASSIGNED_JOBS = [
  {
    id: 'JOB-8842',
    route: 'Ruwais → Jebel Ali Port',
    product: 'Gas Oil / Diesel',
    volume: '42,000 L',
    status: 'in_transit',
    assignedDate: '11 Jun 2026',
    rateAed: 7200,
  },
  {
    id: 'JOB-8843',
    route: 'Jebel Ali → Sharjah Industrial',
    product: 'LPG (Bulk)',
    volume: '28,500 L',
    status: 'accepted',
    assignedDate: '12 Jun 2026',
    rateAed: 4800,
  },
  {
    id: 'JOB-8844',
    route: 'Habshan → Mussafah',
    product: 'Jet Fuel',
    volume: '55,000 L',
    status: 'pending',
    assignedDate: '12 Jun 2026',
    rateAed: 9100,
  },
  {
    id: 'JOB-8845',
    route: 'Fujairah → Dubai South',
    product: 'Bitumen',
    volume: '32 MT',
    status: 'pending',
    assignedDate: '12 Jun 2026',
    rateAed: 6500,
  },
  {
    id: 'JOB-8839',
    route: 'Dubai Industrial → Al Ain',
    product: 'Chemical (Class 3)',
    volume: '18 MT',
    status: 'accepted',
    assignedDate: '10 Jun 2026',
    rateAed: 4200,
  },
];

export const PAYMENT_TRACKING = [
  {
    id: 'PAY-2026-041',
    jobId: 'JOB-8830',
    description: 'May 2026 — 3 completed trips',
    amountAed: 22400,
    status: 'paid',
    paidDate: '2026-06-05',
  },
  {
    id: 'PAY-2026-048',
    jobId: 'JOB-8842',
    description: 'Gas Oil Ruwais → Jebel Ali (In progress)',
    amountAed: 7200,
    status: 'processing',
    paidDate: '—',
  },
  {
    id: 'PAY-2026-049',
    jobId: 'JOB-8843',
    description: 'LPG Jebel Ali → Sharjah (Accepted)',
    amountAed: 4800,
    status: 'awaiting_invoice',
    paidDate: '—',
  },
];

export const PAYMENT_STATUS = {
  paid: { label: 'Paid', className: 'bg-emerald-500/15 text-emerald-700 ring-emerald-500/30' },
  processing: { label: 'Processing', className: 'bg-logi-accent/100/15 text-blue-700 ring-blue-500/30' },
  awaiting_invoice: { label: 'Awaiting Invoice', className: 'bg-amber-500/15 text-amber-700 ring-amber-500/30' },
};

export const VENDOR_FLEET = [
  { id: 'VF-01', vehicleNumber: 'DXB-T-4021', type: 'Fuel Tanker', driver: 'Ahmed Al Mansoori', available: true },
  { id: 'VF-02', vehicleNumber: 'SHJ-C-8810', type: 'Chemical Tanker', driver: 'Rajesh Kumar', available: false },
  { id: 'VF-03', vehicleNumber: 'AUH-L-1155', type: 'LPG Trailer', driver: 'Mohammed Hassan', available: true },
  { id: 'VF-04', vehicleNumber: 'DXB-P-1122', type: 'Bulk Powder', driver: '—', available: false },
];

export const VENDOR_DRIVERS = [
  { id: 'VD-01', name: 'Ahmed Al Mansoori', status: 'on_trip', available: false },
  { id: 'VD-02', name: 'Rajesh Kumar', status: 'checked_in', available: true },
  { id: 'VD-03', name: 'Mohammed Hassan', status: 'on_trip', available: false },
  { id: 'VD-04', name: 'Yusuf Ibrahim', status: 'checked_in', available: true },
];
